<template>
  <v-container>
    <v-row class="text-center">

      <v-col class="mb-4">
        <h1 class="display-2 font-weight-bold mb-10">
          Skill Plans
        </h1>

        <p class="subheading font-weight-regular">
          For new pilots looking for some direction, please see the following skill plans.
          <br/> <br/>
          Note that these are not enforced in any way, but purely here as a guide of what to train if you're
          stuck.
        </p>
      </v-col>

      <v-col
          class="mb-5"
          cols="12"
      >
        <v-row justify="center">
          <v-col cols="12" md="4" class="skill-container">
            <h2 class="headline font-weight-bold mb-3">
              General
            </h2>
            <v-row justify="center">
              <v-card style="overflow-y: auto" height="500" class="grow ma-5">
                <v-list-item v-for="skill in generalSkills" v-bind:key="`general-${skill}`" dense>
                  <v-list-item-content class="justify-start" style="text-align: left">
                    {{skill}}
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-row>
            <v-card-actions>
              <v-btn @click="copyToClipboard('generalSkills')">copy</v-btn>
            </v-card-actions>
          </v-col>
          <v-col cols="12" md="4" class="skill-container">
            <h2 class="headline font-weight-bold mb-3">
              Incursions
            </h2>
            <v-row justify="center">
              <v-card style="overflow-y: auto" height="500" class="grow ma-5">
                <v-list-item v-for="skill in incursionSkills" v-bind:key="`incursion-${skill}`" dense>
                  <v-list-item-content class="justify-start" style="text-align: left">
                    {{skill}}
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-row>
            <v-card-actions>
              <v-btn @click="copyToClipboard('incursionSkills')">copy</v-btn>
            </v-card-actions>
          </v-col>
          <v-col cols="12" md="4" class="skill-container">
            <h2 class="headline font-weight-bold mb-3">
              Mining
            </h2>
            <v-row justify="center">
              <v-card style="overflow-y: auto" height="500" class="grow ma-5">
                <v-list-item v-for="skill in miningSkills" v-bind:key="`mining-${skill}`" dense>
                  <v-list-item-content class="justify-start" style="text-align: left">
                    {{skill}}
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-row>
            <v-card-actions>
              <v-btn @click="copyToClipboard('miningSkills')">copy</v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<style lang="scss" scoped>
  ul {
    list-style: none;
    text-align: left;
    padding-left: 5px;
  }
  .skill-container {
    background-color: rgba(0, 0, 0, 0.6);
  }

</style>
<script>
    export default {
        name: 'SkillPlans',
        methods: {
            copyToClipboard(skillType) {
                let text = this[skillType].join('\n')
                navigator.clipboard.writeText(text)
            }
        },
        data: () => ({
            generalSkills: [
                'EM Armor Compensation I',
                'EM Armor Compensation II',
                'Explosive Armor Compensation I',
                'Explosive Armor Compensation II',
                'Hull Upgrades I',
                'Hull Upgrades II',
                'Hull Upgrades III',
                'Hull Upgrades IV',
                'Kinetic Armor Compensation I',
                'Kinetic Armor Compensation II',
                'Mechanics I',
                'Mechanics II',
                'Mechanics III',
                'Mechanics IV',
                'Repair Systems I',
                'Repair Systems II',
                'Repair Systems III',
                'Thermal Armor Compensation I',
                'Thermal Armor Compensation II',
                'Drones I',
                'Drones II',
                'Drones III',
                'Light Drone Operation I',
                'Light Drone Operation II',
                'Electronic Warfare I',
                'Electronic Warfare II',
                'Electronic Warfare III',
                'Frequency Modulation I',
                'Frequency Modulation II',
                'Long Distance Jamming I',
                'Long Distance Jamming II',
                'Propulsion Jamming I',
                'Propulsion Jamming II',
                'Propulsion Jamming III',
                'Sensor Linking I',
                'Sensor Linking II',
                'Target Painting I',
                'Target Painting II',
                'Weapon Disruption I',
                'Weapon Disruption II',
                'Capacitor Emission Systems I',
                'Capacitor Emission Systems II',
                'Capacitor Management I',
                'Capacitor Management II',
                'Capacitor Management III',
                'Capacitor Systems Operation I',
                'Capacitor Systems Operation II',
                'Capacitor Systems Operation III',
                'CPU Management I',
                'CPU Management II',
                'CPU Management III',
                'CPU Management IV',
                'Electronics Upgrades I',
                'Electronics Upgrades II',
                'Energy Grid Upgrades I',
                'Energy Grid Upgrades II',
                'Energy Grid Upgrades III',
                'Power Grid Management I',
                'Power Grid Management II',
                'Power Grid Management III',
                'Power Grid Management IV',
                'Weapon Upgrades I',
                'Weapon Upgrades II',
                'Weapon Upgrades III',
                'Controlled Bursts I',
                'Controlled Bursts II',
                'Gunnery I',
                'Gunnery II',
                'Gunnery III',
                'Gunnery IV',
                'Motion Prediction I',
                'Motion Prediction II',
                'Motion Prediction III',
                'Rapid Firing I',
                'Rapid Firing II',
                'Sharpshooter I',
                'Sharpshooter II',
                'Sharpshooter III',
                'Small Energy Turret I',
                'Small Energy Turret II',
                'Small Energy Turret III',
                'Small Hybrid Turret I',
                'Small Hybrid Turret II',
                'Small Hybrid Turret III',
                'Small Projectile Turret I',
                'Small Projectile Turret II',
                'Small Projectile Turret III',
                'Surgical Strike I',
                'Surgical Strike II',
                'Trajectory Analysis I',
                'Trajectory Analysis II',
                'Auto-Targeting Missiles I',
                'Auto-Targeting Missiles II',
                'Light Missiles I',
                'Light Missiles II',
                'Light Missiles III',
                'Missile Bombardment I',
                'Missile Bombardment II',
                'Missile Bombardment III',
                'Missile Launcher Operation I',
                'Missile Launcher Operation II',
                'Missile Launcher Operation III',
                'Missile Projection I',
                'Missile Projection II',
                'Rapid Launch I',
                'Rapid Launch II',
                'Rapid Launch III',
                'Rockets I',
                'Rockets II',
                'Rockets III',
                'Target Navigation Prediction I',
                'Target Navigation Prediction II',
                'Target Navigation Prediction III',
                'Acceleration Control I',
                'Acceleration Control II',
                'Acceleration Control III',
                'Afterburner I',
                'Afterburner II',
                'Afterburner III',
                'Evasive Maneuvering I',
                'Evasive Maneuvering II',
                'Evasive Maneuvering III',
                'Fuel Conservation I',
                'Fuel Conservation II',
                'Fuel Conservation III',
                'High Speed Maneuvering I',
                'High Speed Maneuvering II',
                'Navigation I',
                'Navigation II',
                'Navigation III',
                'Navigation IV',
                'Warp Drive Operation I',
                'Warp Drive Operation II',
                'Warp Drive Operation III',
                'Science I',
                'Science II',
                'Shield Compensation I',
                'Shield Compensation II',
                'Shield Management I',
                'Shield Management II',
                'Shield Management III',
                'Shield Operation I',
                'Shield Operation II',
                'Shield Operation III',
                'Shield Upgrades I',
                'Shield Upgrades II',
                'Shield Upgrades III',
                'Tactical Shield Manipulation I',
                'Tactical Shield Manipulation II',
                'Amarr Frigate I',
                'Amarr Frigate II',
                'Amarr Frigate III',
                'Caldari Frigate I',
                'Caldari Frigate II',
                'Caldari Frigate III',
                'Gallente Frigate I',
                'Gallente Frigate II',
                'Gallente Frigate III',
                'Minmatar Frigate I',
                'Minmatar Frigate II',
                'Minmatar Frigate III',
                'Spaceship Command I',
                'Spaceship Command II',
                'Spaceship Command III',
                'Long Range Targeting I',
                'Long Range Targeting II',
                'Long Range Targeting III',
                'Signature Analysis I',
                'Signature Analysis II',
                'Signature Analysis III',
                'Target Management I',
                'Target Management II',
                'Target Management III'
            ],
            miningSkills: [
                'Spaceship Command IV',
                'Industry II',
                'Industry III',
                'Industry IV',
                'Industry V',
                'Mining IV',
                'Astrogeology I',
                'Astrogeology II',
                'Astrogeology III',
                'Astrogeology IV',
                'Mining Frigate II',
                'Mining Frigate III',
                'Mining Barge I',
                'Mining Barge II',
                'Mining Barge III',
                'Mining Barge IV',
                'Mining Barge V',
                'Astrogeology V',
                'Exhumers I',
                'Exhumers II',
                'Exhumers III'
            ],
            incursionSkills: [
                'Capacitor Management I',
                'Capacitor Management II',
                'Capacitor Management III',
                'Capacitor Management IV',
                'Shield Operation I',
                'Shield Operation II',
                'Shield Operation III',
                'Shield Operation IV',
                'Shield Management I',
                'Shield Management II',
                'Shield Management III',
                'Shield Upgrades I',
                'Shield Upgrades II',
                'Shield Upgrades III',
                'Shield Upgrades IV',
                'Shield Rigging I',
                'Shield Rigging II',
                'Tactical Shield Manipulation I',
                'Tactical Shield Manipulation II',
                'Tactical Shield Manipulation III',
                'Tactical Shield Manipulation IV',
                'EM Shield Compensation I',
                'EM Shield Compensation II',
                'Hull Upgrades I',
                'Hull Upgrades II',
                'Hull Upgrades III',
                'Hull Upgrades IV',
                'High Speed Maneuvering I',
                'High Speed Maneuvering II',
                'High Speed Maneuvering III',
                'Afterburner I',
                'Afterburner II',
                'Afterburner III',
                'Signature Analysis I',
                'Signature Analysis II',
                'Signature Analysis III',
                'Long Range Targeting I',
                'Long Range Targeting II',
                'Long Range Targeting III',
                'Target Management I',
                'Target Management II',
                'Target Management III',
                'Target Management IV',
                'Propulsion Jamming I',
                'Propulsion Jamming II',
                'Propulsion Jamming III',
                'Gunnery I',
                'Gunnery II',
                'Gunnery III',
                'Gunnery IV',
                'Gunnery V',
                'Weapon Upgrades I',
                'Weapon Upgrades II',
                'Weapon Upgrades III',
                'Weapon Upgrades IV',
                'Motion Prediction I',
                'Motion Prediction II',
                'Motion Prediction III',
                'Rapid Firing I',
                'Rapid Firing II',
                'Rapid Firing III',
                'Sharpshooter I',
                'Sharpshooter II',
                'Sharpshooter III',
                'Surgical Strike I',
                'Surgical Strike II',
                'Surgical Strike III',
                'Trajectory Analysis I',
                'Trajectory Analysis II',
                'Trajectory Analysis III',
                'Trajectory Analysis IV',
                'Controlled Bursts I',
                'Controlled Bursts II',
                'Controlled Bursts III',
                'Spaceship Command I',
                'Spaceship Command II',
                'Spaceship Command III',
                'Spaceship Command IV',
                'Warp Drive Operation I',
                'Warp Drive Operation II',
                'Warp Drive Operation III',
                'Evasive Maneuvering I',
                'Evasive Maneuvering II',
                'Evasive Maneuvering III',
                'Drones I',
                'Drones II',
                'Drones III',
                'Drones IV',
                'Drones V',
                'Light Drone Operation I',
                'Light Drone Operation II',
                'Light Drone Operation III',
                'Light Drone Operation IV',
                'Heavy Drone Operation I',
                'Heavy Drone Operation II',
                'Heavy Drone Operation III',
                'Drone Interfacing I',
                'Drone Interfacing II',
                'Drone Interfacing III',
                'Drone Navigation I',
                'Drone Navigation II',
                'Drone Navigation III',
                'Drone Sharpshooting I',
                'Drone Sharpshooting II',
                'Drone Sharpshooting III',
                'Drone Avionics I',
                'Drone Avionics II',
                'Drone Avionics III',
                'Drone Durabbility I',
                'Gallente Frigate I',
                'Gallente Frigate II',
                'Gallente Frigate III',
                'Gallente Destroyer I',
                'Gallente Destroyer II',
                'Gallente Destroyer III',
                'Gallente Cruiser I',
                'Gallente Cruiser II',
                'Gallente Cruiser III',
                'Gallente Battlecruiser I',
                'Gallente Battlecruiser II',
                'Gallente Battlecruiser III',
                'Gallente Battleship I',
                'Gallente Battleship II',
                'Gallente Battleship III',
                'Small Hybrid Turret I',
                'Small Hybrid Turret II',
                'Small Hybrid Turret III',
                'Medium Hybrid Turret I',
                'Medium Hybrid Turret II',
                'Medium Hybrid Turret III',
                'Large Hybrid Turret I',
                'Large Hybrid Turret II',
                'Large Hybrid Turret III'
            ],
        })
    }
</script>
